import { cn } from '@/helpers/utils'
import { RadioGroup } from '@headlessui/react'

const SelectList = ({ label = '', options, value, onChange }) => {
  return (
    <RadioGroup value={value} onChange={onChange}>
      <RadioGroup.Label className='sr-only'>{label}</RadioGroup.Label>

      <div className='my-6 flex flex-col gap-2'>
        <For each='option' of={options} index='index'>
          <RadioGroup.Option value={option.value} key={option.value} className='rounded-lg'>
            {({ checked }) => (
              <div
                className={cn(
                  'py-3 px-5 rounded-lg bg-background border border-input',
                  'transition-colors duration-500 ease-in-out',
                  'hover:cursor-pointer hover:bg-accent',
                  checked && 'bg-accent border border-ring'
                )}
              >
                <div className='flex gap-4'>
                  <div className='text-lg'>{option.emoji}</div>
                  <div className='font-medium'>{option.label}</div>
                </div>
              </div>
            )}
          </RadioGroup.Option>
        </For>
      </div>
    </RadioGroup>
  )
}

export default SelectList
